// extracted by mini-css-extract-plugin
export default {"wizardStep":"WizardStep_wizardStep__Xx+gz","currentScreen":"WizardStep_currentScreen__KJVjY","prevScreen":"WizardStep_prevScreen__U7CPR","backButton":"WizardStep_backButton__sCdJ4"};